import React, { Component } from 'react';
import { Map, InfoWindow, Marker, GoogleApiWrapper, Polygon, Polyline } from 'google-maps-react';

import { getDDMMYYYY, getDDMMYYYYHHMMSS, getYYYYMMDDHHMMSS, getDDMMYYYYHHMM, getHyphenYYYYMMDDHHMMSS, getHyphenDDMMYYYYHHMMSS } from '../common/utils';

import Modal from 'react-responsive-modal';

import SweetAlert from 'react-bootstrap-sweetalert';
import CustomLoadingCellRenderer from "../layouts/customLoadingCellRenderer";
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
// //import {ChartMenu} from '@ag-grid-enterprise/charts/dist/es6/chartAdaptor/chartComp/menu/chartMenu';

import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";

// import AndriodMapView from './andriodmapview';
import DrawMap from '../common/drawmap';
import RoutePlayPause from '../layouts/routeAnimate.js';
import { matchPath } from 'react-router';
var redirectURL = require('../redirectURL');
var infoBox = require('../common/google-infowindow');
var moment = require('moment');

var drawingManager;
var selectedShape;
var colors = ['#1D9567', '#1692A5', '#F4D749', '#F73E3E', '#B7B3B3'];
var selectedColor;
var colorButtons = {};
var fencingLength = 0;
var mapZoom = 12;
var coordinates = [];
var geoFencingArea;
export default class MobileTripMaps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mapinfo: '',
            alertshow: 'fade',
            alertmg: 'show-n',
            alerterrmg: 'show-n',
            overly: 'show-n',
            alerterrshow: 'fade',
            alert: null,
            show: false,
            defTransitCoords: '',
            consignercords: '',
            consigneecords: '',
            activeMarker: {},
            selectedPlace: {},
            dealerCode: '',
            timelinesmarkers: [],
            viewtimelinemarkers: true,
            viewgoogleroutes: true,
            googleroutepath: [],
            loadshow: 'show-n',
            open: false,
            deptcode : "SNDG",
            mapToggle: false,
            modules: AllModules,
            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true

            },
            rowData: null,

            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            overlayNoRowsTemplate: "",
            frameworkComponents: {
                customLoadingCellRenderer: CustomLoadingCellRenderer
            },

            animateRows: true,
            debug: true,
            showToolPanel: false,
            uppressAggFuncInHeader: true,

            childconfs: [],
            childrow: [],
            rowModelType: "serverSide",
            paginationPageSize: 50,
            cacheBlockSize: 10,
            maxBlocksInCache: 1,
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left"
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center"
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" }
                ]
            },
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel"
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel"
                    }
                ]
            },
            detailCellRendererParams: {},
            rowClassRules: {
                "highlitRow": "data.transit_delay == 1",
                "green": "data.status >= 3"

            },
            rownode: [],
            googelRoutes: [],
            maptruckno: '',
            dealer: '',
            mapinfo: [],
            defTransitCoords: '',
            showdetails: 'show-n',
            showsecond: 'show-n',
            map_type_of_tracking: "",
            iscustomer: 0,
            hideTVPDealer : 0,
            hidePlantTVP:0
        };

        this.onShowGoogleRoute = this.onShowGoogleRoute.bind(this);
    }
    componentDidMount = async () => {
        this.setState({
            loadshow: 'show-m',
            iscustomer: this.props.match.params.iscustomer,
        });
        // console.log("reqData: ", reqData);
        var params = {
            shipment_id: this.props.match.params.shipmentID
        }
        redirectURL.post('/consignments/getConsignmentInfoByShipmentId', params)
            .then((response1) => {
                var consignmentcodes = []
                var consignmentInfo = response1.data;
                if (consignmentInfo.length > 0) {
                    var { invoice_time, recent_dealer_reported, status, force_closure_time, transit_time, gate_out_time, transit_time, truck_no, gate_in_time, left_dealer_at, left_dealer_marked, invoice_no, consignee_code, deviation_flag, base_route_id, end_time, consignment_code, TVP_STATUS, TVPETA, TVPREACHINGDATE, TVPREACHINGTIME, DEALERSHIPETA, DEALERSHIPREACHINGDATE, DEALERSHIPREACHINGTIME } = response1.data[0];

                    //PMS ID - 9411
                    var tvp_eta = "";
                    var statusConfig = "";

                    var tvpActiveStatus = ["Enroute to TVP", "Near TVP Location"]; // status 2,3
                    var tvpReachedStatus = ["Reached TVP Location", "Primary Trip Completed at TVP"]; // status 4,5
                    var intransitToDealer = ["In Transit to Dealer", "Near Dealer Location"] // status 7,8
                    var reachedDealer = ["Reached at Dealer", "Left From Dealer"] // status 9,10

                    const { location: routerLocation, match } = this.props;
                    if (routerLocation.pathname.includes("/mapView/tvp/")) {
                        if (TVP_STATUS) {

                            if (tvpActiveStatus.includes(TVP_STATUS)) {
                                statusConfig = "TVP ETA";
                                tvp_eta = getDDMMYYYYHHMMSS(TVPETA);
                            }
                            // else if (tvpReachedStatus.includes(TVP_STATUS)) {
                            //     let combined = `${TVPREACHINGDATE}T${TVPREACHINGTIME}Z`;
                            //     tvp_eta = getDDMMYYYYHHMMSS(combined);
                            //     statusConfig = "Reached TVP";
                            // }
                            else if (intransitToDealer.includes(TVP_STATUS)) {
                                statusConfig = "Dealer ETA";
                                tvp_eta = getDDMMYYYYHHMMSS(DEALERSHIPETA);
                            }
                            // else if (reachedDealer.includes(TVP_STATUS)) {
                            //     let combined_eta = `${DEALERSHIPREACHINGDATE}T${DEALERSHIPREACHINGTIME}Z`;
                            //     tvp_eta = getDDMMYYYYHHMMSS(combined_eta);
                            //     statusConfig = "Reached Dealer";
                            // }

                            //hide Dealer when intransit to TVP

                            if (tvpActiveStatus.includes(TVP_STATUS) || tvpReachedStatus.includes(TVP_STATUS)) {
                                this.setState({
                                    hideTVPDealer: 1
                                })

                            }
                            else if (intransitToDealer.includes(TVP_STATUS) || reachedDealer.includes(TVP_STATUS)) {
                                this.setState({
                                    hidePlantTVP: 1
                                });
                            }
                        }
                    }

                    // Detect if current route is TVP
                    const tvpMatch = matchPath(this.props.location.pathname, {
                        path: "/mapView/tvp/:shipmentID",
                        exact: true,
                    });

                    if (tvpMatch) {
                        if (TVP_STATUS && tvpActiveStatus.includes(TVP_STATUS)) {
                            statusConfig = "TVP ETA";
                            tvp_eta = getDDMMYYYYHHMMSS(TVPETA);
                        }
                    }


                    // console.log("consignmentcodes ", consignmentcodes)
                    this.setState({
                        loadshow: 'show-m'
                    });

                    if (invoice_time) {
                        var gateouttime = moment.parseZone(invoice_time).format('YYYY-MM-DD HH:mm:ss');
                    }
                    else {
                        if (gate_in_time) {
                            var gateouttime = moment.parseZone(gate_in_time).format('YYYY-MM-DD HH:mm:ss');
                        }
                        else {
                            if (gate_out_time) {
                                var gateouttime = moment.parseZone(gate_out_time).format('YYYY-MM-DD HH:mm:ss');
                            }
                        }
                    }

                    var edate = '';
                    var end_date;
                    if (status <= 2) {
                        end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
                        edate = getHyphenDDMMYYYYHHMMSS(end_date);
                    }
                    else if (status == 3 || status == 4) {
                        if (recent_dealer_reported) {
                            end_date = recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                            edate = getHyphenDDMMYYYYHHMMSS(recent_dealer_reported);
                        }
                    }
                    else if (status == 5) {
                        if (localStorage.getItem("login_type") == 2 || localStorage.getItem("login_type") == "2") {
                            if (left_dealer_at) {
                                end_date = left_dealer_at.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                                edate = getHyphenDDMMYYYYHHMMSS(left_dealer_at);
                            }
                        } else {
                            if (left_dealer_marked) {
                                end_date = left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                                edate = getHyphenDDMMYYYYHHMMSS(left_dealer_marked);
                            }

                        }
                        // console.log()
                    }
                    else if (status == 6) {
                        if (force_closure_time) {
                            let splitT = force_closure_time.split('T')
                            let yMD = splitT[0]
                            let hMS = splitT[1]
                            let hms1 = hMS.split('.')
                            let finalHms = hms1[0]
                            let final_end_date = yMD + ' ' + finalHms
                            end_date = final_end_date;
                            edate = final_end_date
                        }
                    }
                    else if (status == 7) {
                        if (left_dealer_marked) {
                            let splitT = left_dealer_marked.split('T')
                            let yMD = splitT[0]
                            let hMS = splitT[1]
                            let hms1 = hMS.split('.')
                            let finalHms = hms1[0]
                            let final_end_date = yMD + ' ' + finalHms
                            end_date = final_end_date;
                            edate = final_end_date
                        } else {
                            let splitT = recent_dealer_reported.split('T')
                            let yMD = splitT[0]
                            let hMS = splitT[1]
                            let hms1 = hMS.split('.')
                            let finalHms = hms1[0]
                            let final_end_date = yMD + ' ' + finalHms
                            end_date = final_end_date;
                            edate = final_end_date
                        }
                    }
                    else {
                        end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
                        edate = getHyphenDDMMYYYYHHMMSS(end_date);
                    }

                    if ((transit_time) > 0) {
                        var seconddate = new Date(new Date(gate_out_time).getTime() + ((transit_time + 1) * 24 * 60 * 60 * 1000));
                    }
                    else {
                        var seconddate = new Date(new Date(gate_out_time).getTime() + 2 * 24 * 60 * 60 * 1000);
                    }

                    var sdate = seconddate.getFullYear() + "-" + (seconddate.getMonth() + 1) + "-" + seconddate.getDate() + " " + seconddate.getHours() + ":" + seconddate.getMinutes() + ":" + seconddate.getSeconds();

                    if (!end_date) {
                        end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
                    }
                    var reqData = {
                        truck_no: truck_no,
                        consignment_code: invoice_no,
                        consignee_code: consignee_code,
                        gate_out_time: gateouttime,
                        seconddate: end_date,
                        screen: "consignment",
                        is_tvp: tvpMatch ? 1 : 0,
                        fetch_address:0,
                        display_elis_base_route:0
                    }
                    if ((this.state.deptcode === "SNDG" || this.state.deptcode === "LOG-PRT") && reqData.is_tvp !== 1) {
                        reqData.display_elis_base_route = 1;
                    }
                    if (["2", "3", "4"].includes(status)) reqData.mapMode = 2

                    // console.log("reqData:123 ", reqData);
                    redirectURL.post('/consignments/maproutes', reqData, {
                        headers: {
                            'content-type': 'application/json'
                        }
                    })
                        .then((response) => {
                            var records = response.data;

                            this.setState({
                                loadshow: 'show-m'
                            });
                            try {
                                if (!records || !records.coords || records.coords.length === 0 || records.status === "failure") {
                                    //console.log("records", records.coords);
                                    this.setState({
                                        show: true,
                                        basicTitle: 'GPS NA, Please Contact Team OBL for more detail',
                                        basicType: "danger",
                                        loadshow: 'show-n'
                                    });
                                }
                                else {
                                    if (records != '') {
                                        var sdate = gate_out_time;
                                        if (invoice_time) {
                                            var sdate = invoice_time;
                                        }
                                        else {
                                            if (gate_in_time) {
                                                var sdate = gate_in_time;
                                            }
                                            else {
                                                if (gate_out_time) {
                                                    var sdate = gate_out_time;
                                                }
                                            }
                                        }


                                        var edate = '';
                                        if (status <= 4) {
                                            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
                                            edate = getHyphenDDMMYYYYHHMMSS(end_date);

                                        }
                                        else if (status == 4) {
                                            edate = getHyphenDDMMYYYYHHMMSS(end_time);
                                        }
                                        else if (status == 5) {
                                            if (localStorage.getItem("login_type") == 2 || localStorage.getItem("login_type") == "2") {
                                                if (left_dealer_at) {
                                                    end_date = left_dealer_at.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                                                    edate = getHyphenDDMMYYYYHHMMSS(left_dealer_at);
                                                }
                                                else {
                                                    end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
                                                    edate = getHyphenDDMMYYYYHHMMSS(end_date);
                                                }
                                            } else {
                                                if (left_dealer_marked) {
                                                    edate = getHyphenDDMMYYYYHHMMSS(left_dealer_marked);

                                                }
                                                else {
                                                    end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
                                                    edate = getHyphenDDMMYYYYHHMMSS(end_date);
                                                }
                                            }

                                        }
                                        // console.log(records,'records check')
                                        if (records && records.route_details && tvpMatch) {
                                            let start_time = records.route_details.start_time  // 2025-09-07 00:15:19
                                            let end_time = records.route_details.end_time // 2025-09-13 00:34:58
                                            sdate = start_time
                                            end_date = end_time
                                        }
                                        if (tvpMatch && records && records.coords && records.coords[0]) {
                                            truck_no = records.coords[0].truck_no || ''
                                        }
                                        if (deviation_flag == 1 && this.state.deptcode == "LOG-PRT") {
                                            var params = {
                                                "base_route_id": base_route_id
                                            }
                                            redirectURL.post("/consignments/getLiveRouteDeviationBaseRoute",
                                                params).then((resp) => {
                                                    this.setState({
                                                        sliderRouteTranslate: "slider-translate-60p",
                                                        showDiv: 'show-m',
                                                        mapinfo: records,
                                                        dealer: consignee_code,
                                                        consignment_code: "Invoice No : " + invoice_no,
                                                        maptruckno: truck_no,
                                                        routeTruck: { "truck_no": truck_no, "startTime": sdate, "endTime": end_date, "tvp_eta": tvp_eta, "statusConfig": statusConfig },
                                                        loadshow: 'show-n',
                                                        sidebarSubHeader: "Consignment Information",
                                                        overly: 'show-m',
                                                        rownode: consignmentInfo[0],
                                                        leg_no: 0,
                                                        tolls: records.tolls,
                                                        baseRouteCoords: resp.data.alteredHeroPRTBaseRoute,
                                                        devation_flag: true
                                                    });
                                                    this.onShowGoogleRoute(invoice_no, consignee_code, 0, truck_no)
                                                    this.renderMap();
                                                })
                                        }
                                        else {
                                            this.setState({
                                                sliderRouteTranslate: "slider-translate-60p",
                                                showDiv: 'show-m',
                                                mapinfo: records,
                                                dealer: consignee_code,
                                                consignment_code: "Invoice No : " + invoice_no,
                                                maptruckno: truck_no,
                                                routeTruck: { "truck_no": truck_no, "startTime": sdate, "endTime": end_date, "tvp_eta": tvp_eta, "statusConfig": statusConfig },
                                                loadshow: 'show-n',
                                                sidebarSubHeader: "Consignment Information",
                                                overly: 'show-m',
                                                rownode: consignmentInfo[0],
                                                leg_no: 0,
                                                tolls: records.tolls,
                                                baseRouteCoords: records.base_route,
                                            });
                                            this.onShowGoogleRoute(invoice_no, consignee_code, 0, truck_no)
                                            this.renderMap();
                                        }
                                    }
                                }
                            }
                            catch (e) {
                                console.log(e)
                            }

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
                else {
                    this.setState({
                        show: true,
                        basicTitle: 'GPS NA, Please Contact Team OBL for more detail',
                        basicType: "danger",
                        loadshow: 'show-n'
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }
    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };


    onGridState = () => {
        this.colState = this.gridColumnApi.getColumnState();
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();
        this.pivotColumns = this.gridColumnApi.getPivotColumns();
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }


    onShowGoogleRoute(consignmentcode, consigneecode, legno, truck_no) {
        var reqData = {
            consignment_code: consignmentcode,
            consignee_code: consigneecode,
            leg_no: legno,
            truck_no: truck_no
        }
        // redirectURL.post('/consignments/googlemaproutes', reqData, {
        //     headers: {
        //         'content-type': 'application/json'
        //     }
        // })
        //     .then((response) => {
        //         console.log("Google ", response)
        //         this.setState({
        //             googelRoutes: response.data.googleroute
        //         })
        //     })
        //     .catch(function (e) {
        //         console.log(e)
        //     })
    }

    onClickHideAll() {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            sliderRouteTranslate: '',
            sliderTicketTranslate: '',
            tabsliderTranslate: '',
            inboxSlider: '',
            showsecond: 'show-n'
        });

    }
    onClickShowDetails() {
        this.setState({
            //loadshow:'show-m',
            overly: 'show-m',
            showdetails: 'show-m',
            inboxSlider: 'slider-translatey',
            showsecond: 'show-m'
        });
    }

    closeAlert = () => {
        this.setState({
            show: false
        });
    }

    toggle = () => {
        const currentState = this.state.mapToggle;
        this.setState({ mapToggle: !currentState });
    }


    render() {
        const { location: routerLocation } = this.props; 
        const modalStyles = {
            width: '500px !important',
        }
        const { open } = this.state;
        const tvpMatch = matchPath(routerLocation.pathname, {
            path: "/mapView/tvp/:shipmentID",
            exact: false
        });
        return (

            <div className="col-xl-12 col-md-12 n-p-0">
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                {this.state.alert}
                {/* <div className="row col-xl-12 col-lg-12" style={{ marginBottom: "5px" }}>
                    <span className="layoutbtns pull-right" style={{ paddingRight: "5px" }}>
                        {(this.state.mapfor != "show_location" && this.state.basicTitle != "GPS NA, Please Contact Team OBL for more detail") ?
                            <button className="btn btn-warning float-right" style={{ marginRight: "10px", padding: "5px 5px", fontSize: "14px" }} onClick={this.toggle}>{(this.state.mapToggle) ? "Back To Map" : "Replay"}</button>
                            : ""}
                    </span>
                </div> */}
                {(this.state.mapinfo != '') ?
                    <div className="col-xl-12 col-md-12 n-p-0 mt-2" style={{ height: "100vh" }}>
                        {(this.state.mapToggle) ?
                            <RoutePlayPause
                                coords={this.state.mapinfo}
                            /> :
                            <DrawMap
                                context={this}
                                rownode={this.state.rownode}
                                mapFor={"consignment"}
                                tolls={this.state.tolls}
                                googleroutes={this.state.googelRoutes}
                                truckno={this.state.maptruckno}
                                dealer={this.state.dealer}
                                mapinfo={this.state.mapinfo}
                                defTransitCoords={this.state.defTransitCoords}
                                dept_code={this.state.deptcode}
                                devation_flag={this.state.devation_flag}
                                baseRouteCoords={this.state.baseRouteCoords}
                                suspiciousStoppages={this.state.suspiciousStoppages} 
                                hideTVPDealer = {this.state.hideTVPDealer}
                                hidePlantTVP = {this.state.hidePlantTVP}
                                universalTracking = {1}
                                is_tvp={tvpMatch ? 1 : 0}
                                />
                        }
                        {/* <div className="col-xl-12 col-lg-12 n-p-0">
                            <div className="crm-numbers pb-0">
                                <h3 className="subH">{this.state.sidebarSubHeader}</h3>
                                <div className="col-xl-12 col-lg-12 row">
                                    <div className="col route-block">
                                        <label className="sidebar-label">Truck No</label>
                                        <div>{this.state.routeTruck.truck_no}</div>
                                    </div>
                                    <div className="col route-block">
                                        <label className="sidebar-label">Start Time</label>
                                        <div>{(this.state.routeTruck.startTime != '') ? getDDMMYYYYHHMMSS(this.state.routeTruck.startTime) : "NA"}</div>
                                    </div>
                                    <div className="col route-block">
                                        <label className="sidebar-label">End Time</label>
                                        <div>{(this.state.routeTruck.endTime != '') ? getDDMMYYYYHHMMSS(this.state.routeTruck.endTime) : "NA"}</div>
                                    </div>

                                    <div className="col route-block">
                                        <label className="sidebar-label">GPS Distance</label>
                                        <div>{(!isEmpty(this.state.mapinfo.route_details)) ? Math.round(this.state.mapinfo.route_details.distance_without_google / 1000) : "0"} Kms</div>
                                    </div>
                                    <div className="col route-block">
                                        <label className="sidebar-label">Google Distance</label>
                                        <div>{Math.round(this.state.mapinfo.route_details.distance / 1000)} Kms</div>
                                    </div>


                                </div>
                            </div>
                        </div> */}
                        <div className="col-xl-12 col-lg-12 n-p-0">
                            <div className="crm-numbers pb-0">
                                <h3 className="subH">{this.state.sidebarSubHeader}</h3>
                                <div className="col-xl-12 col-lg-12 row">
                                    <div className="col route-block">
                                        <label className="sidebar-label">Truck No</label>
                                        <div>{this.state.routeTruck.truck_no}</div>
                                    </div>
                                    {/* {(maptransporter != '') ?
                                        <div className="col route-block">
                                            <label className="sidebar-label">Transporter</label>
                                            <div>{(!isEmpty(maptransporter)) ? maptransporter : ""}</div>
                                        </div>

                                        : ""} */}
                                    <div className="col route-block">
                                        <label className="sidebar-label">Start Time</label>
                                        <div>{(this.state.routeTruck.startTime != '') ? getDDMMYYYYHHMMSS(this.state.routeTruck.startTime) : "NA"}</div>
                                    </div>
                                    <div className="col route-block">
                                        <label className="sidebar-label">End Time</label>
                                        <div>{(this.state.routeTruck.endTime != '') ? getDDMMYYYYHHMMSS(this.state.routeTruck.endTime) : "NA"}</div>
                                    </div>

                                    <div className="col route-block">
                                        <label className="sidebar-label">Trip Distance</label>
                                        <div>{(!isEmpty(this.state.mapinfo.route_details)) ? Math.round(this.state.mapinfo.route_details.distance_without_google / 1000) : "0"} Kms</div>
                                    </div>
                                
                                    {this.state.routeTruck &&
                                        this.state.routeTruck.statusConfig === "TVP ETA" &&
                                        routerLocation.pathname.includes("/mapView/tvp/") ? (
                                        <div className="col route-block">
                                            <label className="sidebar-label">
                                                {this.state.routeTruck.statusConfig}
                                            </label>
                                            <div>
                                                {this.state.routeTruck.tvp_eta || "NA"}
                                            </div>
                                        </div>
                                    ) : null}

                                </div>
                            </div>
                        </div>
                        

                    </div>

                    : ''}

                <div className={"dataLoadpage " + (this.state.loadshow)}>
                </div>

                <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                    <div className="loader-box">
                        <div className="rotate dashed colored"></div>
                        <span className="loading-text">Fetching details</span>
                    </div>
                </div>

            </div>
        )
    }
}

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}
